<template lang="pug">
VCard(variant="outlined")
  VListItem.py-2(:to="to")
    template(#prepend)
      CommentaryTypeIcon(
        :color="dark ? 'secondary-c500' : 'secondary-c900'"
        :machine-name="commentaryTypeMachineName"
        variant="outline"
      )
    VListItemTitle {{ commentaryTypeName }}
    VListItemSubtitle(v-if="!!count")
      span(
        v-html="i18n.t('Commentary.comments', { count: count.countHtml }, count.countTotal)"
      )
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { CountData } from "./CommentaryType.util";
import { useDarkMode } from "~/composables/useDarkMode";
import {
  getCommentaryTypeOrFallback,
  getCommentaryTypeUrlName,
} from "~/static/taxonomy/commentaryTypes";

const i18n = useI18n();
const dark = useDarkMode();

interface Props {
  /**
   * The (human-readable) name of the commentary type to switch to when clicking this component.
   */
  commentaryTypeName: string;

  /**
   * The machine name of the commentary type to switch to when clicking this component.
   */
  commentaryTypeMachineName: string;

  /**
   * The actual vids (machine-readable) of comments list to switch to when clicking this component.
   */
  vids: string | undefined;

  count?: CountData;
}

const props = withDefaults(defineProps<Props>(), {});
const to = computed(() => ({
  params: {
    vids: props.vids,
    type: getCommentaryTypeUrlName(
      getCommentaryTypeOrFallback(props.commentaryTypeMachineName),
      i18n.locale.value,
    ),
  },
}));
</script>
